module.exports = __webpack_public_path__ + "img/audiopuse.4d4fd6bc.png";